import {
  formatDateForDb,
  getLastStage,
  maxStagesValidation,
  minStagesValidation,
  sortByDate,
} from '.';
import { v4 as uuidv4 } from 'uuid';
import { IStage, ILine } from '../global';
import { ISnackbar } from '../Types';
import { debounce } from '@material-ui/core';
import messages from '../messages';
import moment from 'moment';

export function addStage(
  stageName: string,
  line: ILine,
  setLine: (line: ILine) => any,
  snackbar: ISnackbar,
  onboarding: boolean = false,
) {
  const maxStages = maxStagesValidation(line.stages);
  if (maxStages) {
    return snackbar.show(messages.lines.maxStages, 'error');
  }
  const lastStage = getLastStage(line.stages);
  const newStage: IStage = {
    new: true,
    id: uuidv4(),
    line: line.id,
    name: stageName,
    amount: 2000,
    start: formatDateForDb(moment(lastStage).add(1, 'month')),
    deleted: false,
  };
  let updatedStages = [...line.stages, newStage];
  if (!onboarding) {
    updatedStages = sortByDate(updatedStages);
  }
  setLine({ ...line, stages: updatedStages });
}

const editStage = (
  line: ILine,
  setLine: (line: ILine) => any,
  id: string,
  key: string,
  value: string | number | boolean,
  snackbar: ISnackbar,
  onboarding: boolean,
) => {
  if (key === 'deleted') {
    const minStages = minStagesValidation(line.stages);
    if (minStages) {
      return snackbar.show(messages.lines.minStages, 'error');
    }
  }
  let newStages = line.stages.map((stage) => {
    if (stage.id === id) {
      stage[key] = value;
      if (key === 'start') {
        stage['needsDateChange'] = false;
      }
    }
    return stage;
  });
  if (!onboarding) {
    newStages = sortByDate(newStages);
  }
  setLine({ ...line, stages: newStages });
};

const editStageWithDebounce = debounce(
  (
    line: ILine,
    setLine: (line: ILine) => any,
    id: string,
    key: string,
    value: string | number | boolean,
    snackbar: ISnackbar,
    onboarding: boolean,
  ) => {
    editStage(line, setLine, id, key, value, snackbar, onboarding);
  },
  300,
);

export const handleEditStage = (
  line: ILine,
  setLine: (line: ILine) => any,
  id: string,
  key: string,
  value: string | number | boolean,
  useDebounce: boolean = false,
  snackbar: ISnackbar,
  onboarding: boolean = false,
) => {
  if (useDebounce) {
    editStageWithDebounce(line, setLine, id, key, value, snackbar, onboarding);
  } else {
    editStage(line, setLine, id, key, value, snackbar, onboarding);
  }
};
